export type CountryCode = "BE" | "NL" | "LU" | "FR" | "DE";

export const EU_COUNTRIES: Array<{ code: CountryCode; label: string }> = [
  { code: "BE", label: "België" },
  { code: "NL", label: "Nederland" },
  { code: "LU", label: "Luxemburg" },
  { code: "FR", label: "Frankrijk" },
  { code: "DE", label: "Duitsland" },
];

export const COUNTRY_LABEL: Record<string, string> = Object.fromEntries(
  EU_COUNTRIES.map((c) => [c.code, c.label]),
);

export interface BillingDetails {
  first_name: string | null;
  last_name: string | null;
  street: string | null;
  house_number: string | null;
  postal_code: string | null;
  city: string | null;
  country: string;
}

export const EMPTY_BILLING: BillingDetails = {
  first_name: null,
  last_name: null,
  street: null,
  house_number: null,
  postal_code: null,
  city: null,
  country: "BE",
};

export function isBillingEmpty(b: BillingDetails): boolean {
  return (
    !b.first_name &&
    !b.last_name &&
    !b.street &&
    !b.house_number &&
    !b.postal_code &&
    !b.city
  );
}
